import { AxiosError } from 'axios'
import { SWRConfiguration } from 'swr'
import useSWRImmutable from 'swr/immutable'
import useSWRMutation, { SWRMutationConfiguration } from 'swr/mutation'
import { ApiPathsFilters, addFilter, getFilters } from './filters.api'
import { FilterOptions, IFilter, IFilters, INewFilter } from './filters.types'

export const defaultFilterOptions: FilterOptions[] = [
  'countries',
  'jobCategories',
  'positionCategories',
  'mainEngineTypes',
  'vesselFleets',
  'totalExperienceOptions',
  'englishLevelOptions',
  'visaOptions',
  'identificationDocuments',
  'candidatesAvailabilityOptions',
  'candidateStatusOptions',
  'certificates',
  'endorsements',
  'dpLicences',
  // Not defined on the backend
  // 'conventionalLiceneseCapacities',
  // 'nationalLicences',
]

export const parseFiltersResponseToInputOptions = (apiFilters: IFilters) => {
  const filters = Object.keys(apiFilters || ({} as IFilters)).reduce((acc, key) => {
    return {
      ...acc,
      [key]: apiFilters?.[key as FilterOptions]?.map((filter: IFilter) => {
        return { label: filter.name, value: filter.id, ...filter }
      }),
    }
  }, {} as IFilters)

  return filters
}

export const useFilters = (config: SWRConfiguration<IFilters> = {}) => {
  const { data, error, isLoading } = useSWRImmutable<IFilters>(
    ApiPathsFilters.filters(defaultFilterOptions),
    getFilters,
    {
      dedupingInterval: 24 * 60 * 60 * 1000,
      ...config,
    },
  )

  return {
    data: parseFiltersResponseToInputOptions(data),
    error,
    isLoading,
  }
}

export const usePartialFilters = (filters: FilterOptions[], config: SWRConfiguration<IFilters> = {}) => {
  const { data, error, isLoading } = useSWRImmutable<IFilters>(ApiPathsFilters.filters(filters), getFilters, {
    ...config,
  })

  return {
    data: parseFiltersResponseToInputOptions(data),
    error,
    isLoading,
  }
}

export const useAddFilter = (config: SWRMutationConfiguration<IFilter, AxiosError, INewFilter, string>) => {
  const { trigger, isMutating } = useSWRMutation(ApiPathsFilters.filters(), addFilter, { ...config })

  return { trigger, isMutating }
}
